<template>
<!-- 主题海报图样式 -->
  <div
    id="jiudiancanyinPic"
    class="jiudiancanyinPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
  <div class="jiudiancanyinContent">
    <div class="jiudianRecommend" v-if="jiudianRecommend ">
      <span  class="label white">酒店推荐:</span>
      <span  class="value white" v-html="jiudianRecommend"></span>
    </div> 
    <div class="canyin" v-if="day">
      <span  class="label white">餐饮:</span>
      <span  class="value white">{{(2*day-1)+'正餐'+(day-1)+'早餐'}}</span>
    </div> 
  </div>
 
  </div>
</template>

<script>
export default {
  name: "jiudiancanyinPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["day","backgroundPic","jiudianRecommend"],
  methods: {
  },

  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
#jiudiancanyinPic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
  position: relative;
}

.jiudiancanyinContent{
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 440px;
  width: 100%;
}
.jiudiancanyinContent > div{
  line-height: 30px;
}
.white{
  color: #fff;
}


</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/jiudiancanyinPic.vue